// libraries
import {
    APPLY_CREDIT_DECISION,
    OPEN_CREDIT_DECISION_SLIDEOUT,
    CLOSE_CREDIT_DECISION_SLIDEOUT,
    GET_CREDIT_APP_DATA_REQUEST,
    GET_CREDIT_APP_DATA_FAILURE,
    GET_CREDIT_APP_DATA_SUCCESS
} from '../actionTypes/creditDecisionActionTypes';
import { scopedActionsCreators, scopedStateSelectors } from '@makemydeal/shared-scoped-store';
import { RSAA } from 'redux-api-middleware';
import { apiConfigHelper, locHrefUtil, MANAGER_VIEW_APP_PREFIX } from '@makemydeal/dr-shared-ui-utils';
import { nanoid } from 'nanoid';

export const updateSelectedCreditDecision = (payload: any) => {
    return {
        type: APPLY_CREDIT_DECISION,
        payload
    };
};

export const openCreditDecisionSlideOut = () => (dispatch: any, getState: any) => {
    const state = getState();
    // Get the current scope ID - this will be the scenario from which the user clicked "View Lender Decisions"
    const currentScopeId = scopedStateSelectors.getCurrentScopeId(state as any);

    // Set the navigation scope target so the credit decision knows which scenario's data to use
    dispatch(scopedActionsCreators.setNavigationScopeTarget(currentScopeId));

    // Open the slideout
    dispatch({ type: OPEN_CREDIT_DECISION_SLIDEOUT });
};

export const closeCreditDecisionSlideOut = () => ({
    type: CLOSE_CREDIT_DECISION_SLIDEOUT
});

export const getCreditAppData = (creditAppId: string, dealerId: number) => (dispatch: any) => {
    const locHref = locHrefUtil.getLocHref();
    const { url: endpoint } = apiConfigHelper.buildBffApiUrl(
        MANAGER_VIEW_APP_PREFIX,
        locHref,
        `/dealer/${dealerId}/creditAppId/${creditAppId}`
    );

    dispatch({
        [RSAA]: {
            endpoint,
            method: 'GET',
            headers: {
                'content-type': 'application/json',
                'x-coxauto-correlation-id': nanoid()
            },
            types: [GET_CREDIT_APP_DATA_REQUEST, GET_CREDIT_APP_DATA_SUCCESS, GET_CREDIT_APP_DATA_FAILURE]
        }
    });
};
